export default __webpack_public_path__ + "static/media/selection.1dbc780b.svg";